import React from 'react';
import MarkdownLayout from '../../Layout/MarkdownLayout';

const TermsConditionContainer = () => {
    return <MarkdownLayout title={'Terms and Conditions'} mdFileName={'TermsConditions'} />;
};

export default TermsConditionContainer;
